import { SCHEMA } from '@vedalib/editor/lib/brand'
import { useCallback, useMemo } from 'react'
import React from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { Typography } from 'components/uiKit/Typography'
import { BrandButtonFont, BrandFormFontBase, BrandGoBack } from 'services/Branding/components'
import { FONT_FIELDS } from 'services/Branding/fieldConfigs'
import { genSchema } from 'services/Branding/genSchema'
import { useElementFontCss, useElementFontValues, useUpdateSchema } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { ReflectionFormBrandType } from './reflectionTypes'

const FONT_FORM_SCHEMA = genSchema(SCHEMA.reflection.font, {
  base: FONT_FIELDS.base,
  placeholder: FONT_FIELDS.base,
})

const TypographyBase: ReflectionFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.base}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.reflection.tags.base')}</Typography>
      </BrandGoBack>
    </BrandFormFontBase>
  )
}

const TypographyPlaceholder: ReflectionFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.placeholder}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.reflection.tags.placeholder')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

const ReflectionTypography: ReflectionFormBrandType = ({ element, edited, device, setForm }) => {
  const { font } = element || {}
  const values = useElementFontValues('reflection', device, font)
  const styles = useElementFontCss('reflection', device, font)

  const goBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <Padding bottom gap sides>
      <BrandGoBack onClick={goBack}>
        <Typography weight='medium'>{t('page.brand.tab.typography')}</Typography>
      </BrandGoBack>
      <BrandButtonFont
        edited={edited.font?.base}
        font='base'
        onClick={setForm}
        styles={styles.base}
        values={values.base}
      >
        {t('elements.reflection.tags.base')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited.font?.placeholder}
        font='placeholder'
        onClick={setForm}
        styles={styles.placeholder}
        values={values.placeholder}
      >
        {t('elements.reflection.tags.placeholder')}
      </BrandButtonFont>
    </Padding>
  )
}

const FONTS_FORM_MAP = {
  [BrandFormEnum.TYPOGRAPHY]: ReflectionTypography,
  base: TypographyBase,
  placeholder: TypographyPlaceholder,
}

export default FONTS_FORM_MAP
